module.exports = __webpack_public_path__ + "img/phpshop.ca4e42bc.png";